import { CustomButton } from '@Modules/core/components';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CorrespondanceAddressDatatableHandler from '../../containers/datatableHandlers/bank/CorrespondanceAddressDatatableHandler/CorrespondanceAddressDatatableHandler';
import MemoDatatableHandler from '../../containers/datatableHandlers/bank/MemoDatatableHandler/MemoDatatableHandler';
import BankPromotorAddressFormHandler from '../../containers/formHandlers/bank/BankPromotorAddressFormHandler/BankPromotorAddressFormHandle';
import BankPromotorFormHandle from '../../containers/formHandlers/bank/BankPromotorFormHandler/BankPromotorFormHandler';
import PromotorMainFormHandler from '../../containers/formHandlers/bank/PromotorFormHandler/PromotorFormHandler';

const tabHeaders = [
  'Promoteur',
  'Companie',
  'Adresse',
  'Adresse Correspondance',
  'Memo',
];
const tabContents = [
  <BankPromotorFormHandle />,
  'Companie',
  <BankPromotorAddressFormHandler />,
  <CorrespondanceAddressDatatableHandler />,
  <MemoDatatableHandler />,
];

export default function Promotor() {
  return (
    <>
      <CC.Box>
        <PromotorMainFormHandler />
      </CC.Box>
      <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} />
    </>
  );
}
